import React from 'react';
import CustomerBalances from "@/common/customer-balances";
import BalanceViewer from "@/common/customer-balances/BalanceViewer";

const LoyaltyModal = () => {

    return (
        <>
            <CustomerBalances
                ViewComponent={BalanceViewer}
            />
        </>
    );
}

export default LoyaltyModal;